<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-file-powerpoint"
      :texto-titulo="'Pedido #'+this.pedido.id"
    ></TituloComponent>
    <div v-if="!loading">
      <div class="main-card mb-3 card">
        <div class="no-gutters row">
          <div class="col-12">
            <div class="widget-content" style="border-bottom: 1px solid rgba(0,0,0,0.125);">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-3">
                  <h4 class="m-0 widget-heading">Cliente:</h4>
                </div>
                <div class="widget-content-left">
                  <h4 class="m-0 widget-heading text-secondary">{{pedido.cliente.nombre}}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-3">
                  <h4 class="m-0 widget-heading">Total:</h4>
                </div>
                <div class="widget-content-left">
                  <h4
                    class="text-success m-0 widget-numbers"
                  >$ {{pedido.total | numFormat('0,0.00')}}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-3">
                  <h4 class="m-0 widget-heading">Fecha:</h4>
                </div>
                <div class="widget-content-left">
                  <h4
                    class="text-default m-0 widget-numbers"
                  >{{pedido.created_at | moment("DD/MM/YYYY")}}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-3">
                  <h4 class="m-0 widget-heading">Estado:</h4>
                </div>
                <div class="widget-content-left">
                  <h4
                    :class="'m-0  widget-numbers text-capitalize '+classEstado()"
                  >{{pedido.estado}}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4" v-if="pedido.entrega && pedido.entrega > 0">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-3">
                  <h4 class="m-0 widget-heading">Entrega:</h4>
                </div>
                <div class="widget-content-left">
                  <h4
                    class="text-success m-0 widget-numbers"
                  >$ {{pedido.entrega | numFormat('0,0.00')}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h4 class="text-capitalize text-secondary">Detalle</h4>
        </div>
        <div class="card-body">
          <ul class="list-group list-group-flush mb-3 detail">
            <li class="list-group-item" v-for="detalle in pedido.detalle" :key="detalle.id">
              <div class="widget-content p-0">
                <div class="widget-content-wrapper row">
                  <div class="widget-content-left col-sm-9 col-12">
                    <h5
                      class="widget-heading text-primary opacity-10"
                    >{{detalle.articulo.codigo}} - {{detalle.articulo.descripcion}}</h5>
                    <div class="widget-subheading opacity-10 row">
                      <span class="col-sm-auto col-6 text-center">
                        Precio:
                        <b class="text-success">${{detalle.importe | numFormat('0,0.00')}}</b>
                      </span>
                      <span class="col-sm-auto col-6 text-center">
                        Cantidad:
                        <b class="text-alternate">{{detalle.cantidad}}</b>
                      </span>
                    </div>
                  </div>
                  <div class="widget-content-right col-sm-3 text-sm-right text-center">
                    <div class="widget-numbers text-danger">
                      <span
                        class="count-up-wrapper"
                      >${{(detalle.importe * detalle.cantidad) | numFormat('0,0.00')}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="card p-2 mt-2 mb-2">
        <div class="row">
          <div class="col-md-2">
            <button
              class="btn btn-default btn-block mb-2 mb-md-0"
              type="button"
              @click="$router.go(-1)"
            >Volver</button>
          </div>
          <div class="col-md-2 offset-md-6" v-if="pedido.estado == 'pendiente' && user.tipo == 'Administrador'">
            <router-link
              class="btn btn-block btn-info text-white mb-2 mb-md-0"
              :to="{name:'NuevoComprobante', params:{pedido_id:pedido.id}}"
            >Facturar</router-link>
          </div>
          <div class="col-md-2" v-if="pedido.estado == 'pendiente' && user.tipo == 'Administrador'">
            <button class="btn btn-danger btn-block mb-2 mb-md-0" type="button">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import Pedido from "@/models/pedido";
import axios from "axios";
import BlockUI from "@/components/loaders/BlockUI";
import { mapGetters } from "vuex";
export default {
  name: "VerPedido",
  components: {
    TituloComponent,
    BlockUI
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    })
  },
  data() {
    return {
      pedido: new Pedido(
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        {},
        {},
        {},
        []
      ),
      loading: false
    };
  },
  mounted() {
    this.pedido.id = this.$route.params.id;
    this.getPedido();
  },
  methods: {
    getPedido() {
      this.loading = true;
      axios
        .get("/pedidos/" + this.pedido.id)
        .then(res => {
          if (res.data.success) {
            this.pedido = res.data.pedido;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    classEstado() {
      switch (this.pedido.estado) {
        case "pendiente":
          return "text-warning";
        case "realizado":
          return "text-success";
        case "cancelado":
          return "text-danger";
        default:
          return "";
      }
    }
  }
};
</script>
<style>
</style>